import { exists } from "fs";
var existsAsync = function existsAsync2(file) {
  return new Promise(function(res, rej) {
    try {
      exists(file, res);
    } catch (unused) {
      return false;
    }
  });
};
export {
  existsAsync
};
//# sourceMappingURL=existsAsync.js.map
